import React from 'react';

interface SeasonSelectorProps {
  selectedSeason: string | null;
  setSelectedSeason: (season: string) => void;
}

export default function SeasonSelector({
  selectedSeason,
  setSelectedSeason,
}: SeasonSelectorProps) {
  const seasons = ['winter', 'summer'];

  return (
    <div className="flex justify-center flex-wrap gap-4 mt-10 mb-6">
      {seasons.map((season) => (
        <label
          key={season}
          className={`flex items-center gap-2 px-4 py-2 rounded-full cursor-pointer transition duration-300 border ${
            selectedSeason === season
              ? 'bg-blue-600 text-white border-blue-600'
              : 'bg-white dark:bg-gray-700 border-gray-300 hover:bg-blue-100 dark:hover:bg-gray-600'
          }`}
        >
          <input
            type="radio"
            name="season"
            value={season}
            className="hidden"
            checked={selectedSeason === season}
            onChange={() => setSelectedSeason(season)}
          />
          <span className="font-medium">
            {season.charAt(0).toUpperCase() + season.slice(1)}
          </span>
        </label>
      ))}
    </div>
  );
}
